const Subcategories = {
  REMOVALS_AUTOQUALIFIED: {
    id: '3d3e301b-127a-c0bf-1793-5085433585e7',
  },
};

export default Subcategories;
